import type { Underlying } from 'models/underlying';
import { FC, PropsWithChildren, useRef, useState } from 'react';
import { Overlay, OverlayProps, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

import { UnderlyingTooltip } from './Tooltip/Tooltip';

export interface WithUnderlyingInfoTooltipProps {
  underlying?: Underlying;
  placement?: OverlayProps['placement'];
  className?: string;
  hasCutOff?: boolean;
  hasLegacyEsgEligibilityIcon?: boolean;
}

const StyledTooltip = styled(Tooltip)`
  & > .tooltip-inner {
    padding: 0px;
  }
`;
export const WithUnderlyingInfoTooltip: FC<PropsWithChildren<WithUnderlyingInfoTooltipProps>> = ({
  underlying,
  children,
  placement,
  className,
  hasCutOff,
}) => {
  const iconRef = useRef<HTMLDivElement | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout>(undefined);

  const [isTooltipOpened, setIsTooltipOpened] = useState(false);

  const closeTooltip = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setIsTooltipOpened(false);
    }, 350);
  };

  const openTooltip = () => {
    clearTimeout(timeoutRef.current);
    setIsTooltipOpened(true);
  };

  const leaveUnderlyingTooltipHandler = () => {
    clearTimeout(timeoutRef.current);
    setIsTooltipOpened(false);
  };

  return (
    <>
      <div ref={iconRef} className={className} onMouseLeave={closeTooltip} onMouseEnter={openTooltip}>
        {children}
      </div>
      <Overlay target={iconRef.current} show={Boolean(isTooltipOpened && underlying)} placement={placement ?? 'bottom'}>
        <StyledTooltip>
          {underlying && (
            <UnderlyingTooltip
              underlying={underlying}
              hasCutOff={hasCutOff}
              onMouseLeave={leaveUnderlyingTooltipHandler}
              onMouseEnter={openTooltip}
            />
          )}
        </StyledTooltip>
      </Overlay>
    </>
  );
};
